import { createStore } from 'redux';

import rootReducer from './reducers';

const Store = createStore(rootReducer);

export type AppDispatch = typeof Store.dispatch;

export default Store;
